import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import PositionedEffect from '../../../domain/entities/PositionedEffect';

export default function reducer(
  state: {[key: number]: PositionedEffect} = {},
  action: AnyAction,
): {[key: number]: PositionedEffect} {
  switch (action.type) {
    case Types.IndexPositionedEffectsSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (
            obj: {[key: number]: PositionedEffect},
            record: PositionedEffect,
          ) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowPositionedEffectSuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
